import { axiosInstance } from "./axios";
import useCustomQuery from "hooks/useCustomQuery";
import { IChat } from "dto/ContactForm/IChat";

const queryKeys = {
  getChat: () => "contactFormService.getChat",
};

const getChat = (
  token: string,
  connectionId?: string,
): Promise<{ data: IChat }> => {
  return axiosInstance.get(
    `/contactForm/chat/init?token=${token}&connectionId=${connectionId}`,
  );
};

const useGetChat = (
  token: string,
  connectionId?: string,
  enabled: boolean = true,
) => {
  return useCustomQuery(
    queryKeys.getChat(token, connectionId),
    () => getChat(token, connectionId),
    {
      enabled: enabled,
    },
  );
};

export default {
  useGetChat,
};
